export const attentionItems = {
  'offer-list': { key: 'offers', label: 'offers needing attention', attention: 'needs-attention' },
  'placement-list': { key: 'placements', label: 'placements needing attention', attention: 'needs-attention' },
  'advertiser-list': { key: 'advertisers', label: 'advertisers failed to fetch latest offers', attention: 'api-failures' },
};

export function getMenuAttention({ item, counts, permissions }) {
  if (item.permission && !permissions[item.permission]) return { count: 0, title: '' };
  if (item.children) {
    const children = item.children.map(child => getMenuAttention({ item: child, counts, permissions }));
    return {
      count: children.reduce((total, child) => total + child.count, 0),
      title: children.filter(child => child.count > 0).map(child => child.title).join('\n'),
    };
  }
  const definition = attentionItems[item.name];
  const value = definition ? counts[definition.key] : 0;
  const count = Number.isSafeInteger(value) && value > 0 ? value : 0;
  return { count, title: count ? `${count} ${definition.label}` : '' };
}

export function getAttentionFilters({ routeName, query, defaults }) {
  const definition = attentionItems[routeName];
  if (!definition || query.attention !== definition.attention) return null;
  const filters = { ...defaults };
  switch (routeName) {
    case 'offer-list':
      return { ...filters, needs_attention: true, flagged: false, status: 'all', show_hidden: true };
    case 'placement-list':
      return { ...filters, needs_attention: true, flagged: false, placement_status: 'all', offer_status: 'all' };
    case 'advertiser-list':
      return { ...filters, api_failures: true, status: undefined };
  }
}

export function formatAttentionCount(count) {
  return count > 99 ? '99+' : String(count);
}
